import App from './App.vue'
import Components from './components';
import store from './utils/store';
import i18n from './utils/i18n';
import EventBus from './utils/eventBus';
import HTTP from './utils/axios';
import {createApp} from "vue";

const app = createApp(App);

app.config.globalProperties.$http = HTTP;

app.use(Components)
app.use(store)
app.use(i18n)
app.use(EventBus);

app.mount('#app')
